export const TAG_NAME_MIN_LENGTH = 1;
export const TAG_NAME_MAX_LENGTH = 50;

export function normalizeTagName(name) {
  return typeof name === 'string' ? name.trim() : '';
}

export function extractTagNamesFromInput(value) {
  if (typeof value !== 'string') {
    return [];
  }

  return [...new Set(value
    .split(',')
    .map((part) => normalizeTagName(part))
    .filter(Boolean))];
}

export function normalizeTagNames(values) {
  if (!Array.isArray(values)) {
    return [];
  }

  return [...new Set(values
    .map((value) => {
      if (typeof value === 'string') {
        return normalizeTagName(value);
      }

      if (value && typeof value === 'object' && 'name' in value) {
        return normalizeTagName(value.name);
      }

      return '';
    })
    .filter(Boolean))];
}
